import { NamingConfig } from '@shared/naming/naming-config';

export type IntegrationConfig = {
  id: string;
  customerId: string;
  name: string;
  sourceType: string;
  endpointUrl: string;
  httpMethod?: string | null;
  sftpFilePath?: string | null;
  requestHeaders?: string;
  templateId?: string;
  internalEventId?: string | null;
  schedule: string[];
  /** Minutes between runs; set instead of `schedule`, never alongside it (IN-193). */
  intervalMinutes?: number | null;
  isEnabled: boolean;
  authConfigId?: string | null;
  createdUtc?: string;
  createdBy: string;
  updatedUtc?: string;
  updatedBy?: string;
  deletedUtc?: string;
  deletedBy?: string;
};

export const IntegrationConfigNaming = NamingConfig<IntegrationConfig>({
  key: 'IntegrationConfig',
  modelName: { '=1': $localize`Inbound Config`, other: $localize`Inbound Configs` },
  fieldNames: {
    id: $localize`ID`,
    customerId: $localize`Customer ID`,
    name: $localize`Name`,
    sourceType: $localize`Source Type`,
    endpointUrl: $localize`Endpoint URL`,
    httpMethod: $localize`HTTP Method`,
    sftpFilePath: $localize`SFTP File Path`,
    requestHeaders: $localize`Request Headers`,
    templateId: $localize`Template`,
    internalEventId: $localize`Internal Event`,
    schedule: $localize`Schedule`,
    intervalMinutes: $localize`Interval (minutes)`,
    isEnabled: $localize`Enabled`,
    authConfigId: $localize`Auth Config`,
    createdUtc: $localize`Created`,
    createdBy: $localize`Created By`,
    updatedUtc: $localize`Updated`,
    updatedBy: $localize`Updated By`,
    deletedUtc: $localize`Deleted`,
    deletedBy: $localize`Deleted By`,
  },
});
